import { Stack } from "@mui/material";
import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/elements/Button";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { AppRoutes } from "@/routes/config";

type TPartnerFooterContainerProps = {
  children?: ReactNode;
};

export const PartnerFooterContainer: FC<TPartnerFooterContainerProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <FooterContainer>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={3}>
        <Button size="sm" variant="ghost" onClick={() => navigate(AppRoutes.partnerList)}>
          戻る
        </Button>
        {children}
      </Stack>
    </FooterContainer>
  );
};
